<template>
    <div class="table-list process">
        <virtual-account  :key="'a'+componentKey" :task="taskId"></virtual-account>
        <view-house-detail  :key="'b'+componentKey" :task="taskId" :tasker="takerName"></view-house-detail>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="cover">房源圖片</span>
            <span class="task-date">委託時間</span>
            <span class="house">房源名稱</span>
            <span class="name">受託人</span>
            <span class="pay-way">付款方式</span>
            <span class="status">狀態</span>
            <span class="bonus">委託獎金</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <!-- <div v-show="taskProcessList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div> -->
            <div v-show="taskProcessList.length == 0" class="is-empty">0 筆資料</div> 
            <ul>
                <li v-for="(task,index) in taskProcessList" :key="index">
                    <span v-if="task.houseCoverImage" class="cover">
                        <img :src="imageUrl(task.houseCoverImage)" alt="">
                    </span>
                    <div v-else class="cover">
                        <img src="@/assets/img/component/houseCard/default.svg" alt="">
                    </div>
                    <span class="task-date">{{getFormatDate(task.taskBeginTime)}} - {{getFormatDate(task.taskEndTime)}}</span>
                    <span class="house">{{task.houseName}}</span>
                    <span class="name">{{task.taskTakerName}}</span>
                    <span class="pay-way">{{transPayWay(task.paymentType)}}</span>
                    <span class="status">
                        <span class="blue" v-if="task.taskStatus == 2">進行中</span>
                        <span class="red" v-if="task.taskStatus == 9 ">待付款</span>
                        <span class="gray" v-if="task.taskStatus == 1 ">待接受</span>
                    </span>
                    <span class="bonus">{{toCurrency(task.taskBonus)}}</span>
                    <span v-if="task.taskStatus == 2" class="action">
                        <dot-dropmenu>
                            <ul >
                                <li @click="getViewHouseDetail(task.taskCid,task.taskTakerName), $analytics.logEvent('看屋明細', { screen_name: '看屋明細'})">看屋明細</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                    <span v-if="task.taskStatus == 9" class="action">
                        <dot-dropmenu>
                            <ul >
                                <li @click="getVirtualAccount(task.taskCid), $analytics.logEvent('付款明細', { screen_name: '付款明細'})">付款明細</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import constant from '@/constant'
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import Modal from '@/components/widge/Modal.vue';
import VirtualAccount from '@/components/widge/VirtualAccount.vue';
import ViewHouseDetail from '@/components/widge/ViewHouseDetail.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import { 
    apiGetTaskProcess,
    apiGetTaskFinished,
    } from "@/apis/api.js"; 
export default {
    data () {
        return {
            componentKey: 0,
            taskProcessList: [],
            taskId: null,
            takerName: null,
            filterWord: '',
            filterEmpty: false,
            taskProcessDataEmpty: false,
            taskProcessDataError: false,
            alarm: false,   
            deleteId: '',
            isDefault: false,
            isLoading: false,
            totalPage: 0
        }
    },
    mounted () {
        this.getTaskProcessList(1)
    },
    watch: {
        totalPage: function (page) {
            if(page > 1){
                for (let i = 2; i <= page; i++) {
                    this.getTaskProcessList(i)
                }
            }
        }
    },
    methods: {
        getSelectId: function (value) {
            this.isDefault = false

            // if( value.ref == 'finished' ){
            //     if(value.id == 1){
            //         this.contractState = [9]
            //     }else if(value.id == 2){
            //         this.contractState = [4, 6, 8]
            //     }else if(value.id == 3){
            //         this.contractState = [3, 5]
            //     }
            // }
        },
        closeModal: function (type) {
            this.alarm = false
        },
        openModal: function () {
            this.alarm = true
            this.deleteId = event.target.dataset.id
        },
        setFilterWord: function (value) {
            this.isDefault = false
            this.filterWord = value
        },
        setFilterDefault: function (value) {
            this.isDefault = true
            this.filterWord = ''
            this.contractState = ''
        },
        transPayWay: function (value) {
            if( value == 'WALLET' ){
                return '飛豬錢包'
            }else if( value == 'TRANSFER' ) {
                return '匯款轉帳'
            }else if( value == 'TASK_REFUND' ) {
                return '系統退款'
            }else if( value == 'DEPOSIT_FORFEIT' ) {
                return '訂金補償'
            }
        },
        getTaskProcessList: function (page) {
            apiGetTaskProcess(page)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.totalPage = res.data.result.totalPage
                    res.data.result.houseTaskVoList.map( item => {
                        this.taskProcessList.push(item) 
                    })
                }
            })
            .catch(err => {
                reject(err)
            })
        },
        getVirtualAccount: function (id) {
            this.componentKey += 1
            this.taskId = id
            document.getElementsByClassName('task-management')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'virtualAccount'})
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        getViewHouseDetail: function (id, taker) {
            console.log(id)
            this.componentKey += 1
            this.taskId = id
            this.takerName = taker
            document.getElementsByClassName('task-management')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'viewHouse'})
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        imageUrl: function (url){
            return constant.imageUrl+url
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    computed: {
     
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal,
        RentSelect,
        TableSearch,
        VirtualAccount,
        ViewHouseDetail
    }
}
</script>
<style lang="scss" scoped>
    .process{
        .table-list-title .cover,
        .table-list-body ul li .cover{
            position: relative;
            width: 120px;
            margin-right: 50px;
        }
        .table-list-title .task-date,
        .table-list-body ul li .task-date{
            width: 160px;
            margin-right: 42px;
        }
        .table-list-title .house,
        .table-list-body ul li .house{
            width: 190px;
            margin-right: 48px;
        }
        .table-list-title .name,
        .table-list-body ul li .name{
            width: 56px;
            margin-right: 42px;
        }
        .table-list-title .pay-way,
        .table-list-body ul li .pay-way{
            width: 56px;
            margin-right: 50px;
        }
        .table-list-title .status,
        .table-list-body ul li .status{
            width: 76px;
            margin-right: 51px;
        }
        .table-list-title .bonus,
        .table-list-body ul li .bonus{
            width: 56px;
            margin-right: 50px;
        }
        .table-list-body ul li .bonus{
            text-align: right;
        }
        .table-list-body .cover{
            width: 120px;
            height: 90px;
            border-radius: 4px;
            margin-right: 16px;
            display: flex;
            align-items: center;
            border-radius: 4px;
            overflow: hidden;
            >img{
                width: 100%;
            }
        }
        .table-list-body ul li .status{
            >span{
                width: 76px;
                height: 38px;
                border-radius: 4px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .red{
                background-color: rgba(255, 146, 117, 0.1);
                color: #fc7171;
            }
            .blue{
                background-color: rgba(113, 170, 229, 0.1);
                color: #71aae5;
            }
            .gray{
                background-color: #f3f3f3;
                color: #676362;
            }
        }
    }
    @media screen and (max-width: 1280px){
        .process{
            .table-list-title .cover,
            .table-list-body ul li .cover{
                margin-right: 47px;
            }
            .table-list-title .task-date,
            .table-list-body ul li .task-date{
                margin-right: 48px;
            }
            .table-list-title .house,
            .table-list-body ul li .house{
                margin-right: 49px;
            }
            .table-list-title .name,
            .table-list-body ul li .name{
                margin-right: 48px;
            }
            .table-list-title .pay-way,
            .table-list-body ul li .pay-way{
                margin-right: 49px;
            }
            .table-list-title .status,
            .table-list-body ul li .status{
                margin-right: 48px;
            }
            .table-list-title .bonus,
            .table-list-body ul li .bonus{
                margin-right: 48px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/taskManagement/taskProcessList.vue